module.exports = __webpack_public_path__ + "assets/images/user_purple.svg?3ddb433e8086f52fecbf88464a31b6c7";


//////////////////
// WEBPACK FOOTER
// ./_source/images/icons/sessions/user_purple.svg
// module id = 21
// module chunks = 0